import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, ListChecks, Clock } from "lucide-react";

export default function ParentAssignmentsBanner() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let alive = true;
        api.get("/parent/assignments")
            .then((r) => alive && setItems(r.data || []))
            .catch(() => {});
        return () => { alive = false; };
    }, []);

    const pending = items.filter((a) => !a.opened_at && !a.is_expired);
    if (pending.length === 0) return null;

    return (
        <div className="bg-amber-50 border-2 border-amber-300 rounded-2xl p-4 mb-5" data-testid="parent-assignments-banner">
            <div className="flex items-center gap-3 mb-2">
                <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0" />
                <div className="flex-1">
                    <div className="font-bold text-amber-900 text-sm">
                        {pending.length} detyrë{pending.length > 1 ? "e të pa-hapura" : " e pa-hapur"} për fëmijën tuaj
                    </div>
                    <div className="text-[11px] text-amber-700">Inkurajoni fëmijën ta hapë sa më parë për të ndaluar njoftimet ditore.</div>
                </div>
            </div>
            <div className="space-y-1.5">
                {pending.slice(0, 3).map((a) => (
                    <div key={a.id} className="flex items-center gap-2 px-3 py-1.5 bg-white border border-amber-200 rounded-md text-xs">
                        <ListChecks className="w-3.5 h-3.5 text-amber-700 shrink-0" />
                        <div className="flex-1 min-w-0">
                            <div className="font-bold text-slate-900 truncate">{a.title}</div>
                            <div className="text-[10px] text-slate-500">{a.student_name} • {a.teacher_name}</div>
                        </div>
                        <span className="inline-flex items-center gap-1 text-[10px] font-bold text-amber-700 shrink-0">
                            <Clock className="w-3 h-3" /> {a.days_remaining}d
                        </span>
                    </div>
                ))}
                {pending.length > 3 && (
                    <div className="text-[11px] text-amber-700 text-center pt-1">+{pending.length - 3} të tjera</div>
                )}
            </div>
        </div>
    );
}
